import { render, staticRenderFns } from "./PaymentScreen.vue?vue&type=template&id=1a107b91&"
import script from "./PaymentScreen.vue?vue&type=script&lang=js&"
export * from "./PaymentScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports